export const CARE_TEAM_PATH = 'v1/care-team';
